import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { AdminState } from './state';

const defaultState: AdminState = {
  users: [],
  categories: [],
  videos: [],
  news: [],
  subs: [],
};

export const adminModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
